import { useTranslation } from "react-i18next"
import { TypeOfActivity } from "../../logic/keuzewijzer/keuzewijzerenums"
import { useState, useRef } from "react"
import { RadioInput } from "../../components/RadioInput"

export function TypeOfActivityPage({ setState }: { setState: (arg0: TypeOfActivity) => void }) {
  const { t } = useTranslation(["keuzewijzer", "common"])
  const refs = useRef<(HTMLSpanElement | null)[]>([]);

  const [data, setData] = useState<TypeOfActivity>()

  const handleRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData(+event.target.value)
  }

  function handleButton() {
    if (data !== undefined) {
      setState(data)
    }
  }
  
  const master: any = [
    {
      label: t("typeOfActivity__label_main"),
      id: 'main',
      name: 'typeOfActivity',
      value: TypeOfActivity.Main,
    },
    {
      label: t("typeOfActivity__label_secondary"),
      id: 'secondary',
      name: 'typeOfActivity',
      value: TypeOfActivity.Secondary,
    },
  ]

  return (
    <div>
      <h2>{t("typeOfActivity__title")}</h2>

      <div className="wrapper-col">
        {
          master.map((el:any, index:any) => {
            return (
              <RadioInput 
                label={ el.label }
                id={ el.id }
                name={ el.name }
                index={ index }
                value={ el.value }
                refs={ refs }
                handler={ handleRadio }
              />
            )
          })
        }
      </div>

      <button onClick={handleButton} className="button-primary">{t("button__next", { ns: "common" })}</button>
    </div>
  )
}